import { apiRequest } from "../../shared/api/client";
import { validateOfferEntry } from "./domain/offer-entry";
import type { OfferEntryInput } from "./domain/offer-entry";
export * from "./domain/offer-entry";

function optionalNumber(value?: string) {
  return value === undefined || value === "" ? undefined : Number(value);
}

export async function saveOfferEntry<T extends { id: string }>({
  input,
  editingOfferId,
  document,
}: {
  input: OfferEntryInput;
  editingOfferId?: string | null;
  document?: File | null;
}) {
  const validationError = validateOfferEntry(input);
  if (validationError) throw new Error(validationError);

  const saved = await apiRequest<T>(
    editingOfferId
      ? `/api/offers/${encodeURIComponent(editingOfferId)}`
      : "/api/offers",
    {
      method: editingOfferId ? "PUT" : "POST",
      body: JSON.stringify({
        requestNo: input.requestNo,
        supplierId: input.supplierId,
        unitPrice: input.unitPrice,
        currency: input.currency,
        paymentDays: Number(input.paymentDays),
        deliveryDays: Number(input.deliveryDays),
        procurementNote: input.procurementNote,
        validUntil: input.validUntil,
        shippingCost: optionalNumber(input.shippingCost),
        insuranceCost: optionalNumber(input.insuranceCost),
        installationCost: optionalNumber(input.installationCost),
        otherCost: optionalNumber(input.otherCost),
        otherCostDescription: input.otherCostDescription,
        documentPresent: Boolean(document),
      }),
    },
  );

  const documentUpload = document
    ? (() => {
        const documentBody = new FormData();
        documentBody.set("file", document);
        documentBody.set("offerNo", saved.id);
        return apiRequest(`/api/requests/${input.requestNo}/attachments`, {
          method: "POST",
          body: documentBody,
        });
      })()
    : null;

  return { saved, documentUpload };
}
